import { TwinMessage } from 'api/model'
import { atom, atomFamily } from 'recoil'

const messagesByConversationFamily = atomFamily<TwinMessage[], string>({
  key: 'messagesByConversationFamily',
  default: [],
})

const myTwinMessagesAtom = atom<TwinMessage[]>({
  key: 'myTwinMessages',
  default: [],
})

export { messagesByConversationFamily, myTwinMessagesAtom }
